import { CloseCircle, InfoCircle, TickCircle } from 'iconsax-react';
import cn from '@/utils/merge-class-names';

type Props = {
  className?: string;
  success: boolean;
  successText?: string;
  failText?: string;
  isLoading?: boolean;
  isIntermediate?: boolean;
  intermediateText?: string;
};

export default function SuccessIndicator({
  className,
  success,
  successText,
  failText,
  isLoading,
  isIntermediate,
  intermediateText,
}: Props) {
  if (isLoading) {
    return (
      <div className={cn('flex items-center gap-1', className)}>
        <span className='loading loading-ring loading-sm' />
      </div>
    );
  }

  if (isIntermediate) {
    return (
      <div className={cn('flex items-center gap-1', className)}>
        {intermediateText}
        <InfoCircle
          variant='Bold'
          className='size-5 text-warning'
        />
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-1', className)}>
      {success ? successText : failText}
      {success ? (
        <TickCircle
          variant='Bold'
          className='size-5 text-success'
        />
      ) : (
        <CloseCircle
          variant='Bold'
          className='size-5 text-error'
        />
      )}
    </div>
  );
}
